import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import { LineChart, Interpolation } from 'chartist';
import { ChartistPluginTooltip } from './chartist-plugin-tooltips';
import QRCode from 'qrcode';
import 'chartist/dist/index.css';
import 'flatpickr';
import 'flatpickr/dist/themes/airbnb.css';
import 'flatpickr/dist/l10n/nl.js';
import '@github/relative-time-element';

window.Alpine = Alpine;
window.Chartist = {
    'LineChart': LineChart,
    'Interpolation': Interpolation,
};
window.ChartistPluginTooltip = ChartistPluginTooltip;
window.QRCode = QRCode;

Livewire.start();
